export { default as UploadManager } from './UploadManager';
